module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "parent",
    staticClass: "cb-header__wrap cb-transition__slide",
    attrs: {
      "id": "cb-header-wrap",
      "role": "banner"
    }
  }, [(_vm.logo) ? _c('div', {
    staticClass: "cb-header__logo"
  }, [_c('img', {
    staticClass: "cb-header__image",
    attrs: {
      "src": _vm.logo,
      "alt": "logo"
    }
  })]) : _vm._e(), _vm._v(" "), _c('cb-slide-n-fade', [(this.$route.meta.headerTitle && this.$route.meta.nonLoggedInUser) ? _c('div', {
    staticClass: "cb-header__title",
    class: {
      'cb-header__title--xl': !_vm.logo
    },
    style: (_vm.themeColor),
    attrs: {
      "id": "cb-header-title"
    }
  }, [_vm._v("\n\t\t  " + _vm._s(_vm.nlt(this.$route.meta.headerTitle)) + "\n\t\t")]) : _c('div', {
    staticClass: "cb-header__title",
    class: {
      'cb-header__title--xl': !_vm.logo
    },
    style: (_vm.themeColor),
    attrs: {
      "id": "cb-header-title"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.t(this.$route.meta.headerTitle)) + "\n\t\t")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed94045e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/headers/PortalHeader.vue
// module id = 612
// module chunks = 66